import * as styles from "./ColorPickerValue.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useColorPickerContext } from "./ColorPicker.context";
import type { ColorPickerValueProps } from "./ColorPicker.types";

export function ColorPickerValue({
  className,
}: ColorPickerValueProps): JSX.Element {
  const { hex } = useColorPickerContext();

  return (
    <span
      data-slot="color-picker-value"
      className={clsx(styles.value, className)}
      style={{ backgroundColor: hex }}
    />
  );
}
